// removed by extract-text-webpack-plugin
module.exports = {"ratingFieldSet":"FieldReviewRating__ratingFieldSet__1Uqpy","rating":"FieldReviewRating__rating__14nrr","rateInput":"FieldReviewRating__rateInput__2jLUx","label":"FieldReviewRating__label__2fAuT","star":"FieldReviewRating__star__1Pj0E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FieldReviewRating/FieldReviewRating.css
// module id = 1805
// module chunks = 0